import { render, staticRenderFns } from "./allocationDevice.vue?vue&type=template&id=4f0a1fe0&"
import script from "./allocationDevice.vue?vue&type=script&lang=js&"
export * from "./allocationDevice.vue?vue&type=script&lang=js&"
import style0 from "./allocationDevice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports